/* global Vue, LOYALTY_INTERESTS */

import AwardCard from './AwardCard'

export default {
  name: 'AwardCardList',
  components: { AwardCard },
  template: `
<div>
  <div v-if="useFilters" class="grid no-row-gap loyalty-awards__filters select-filters">
    <div class="col-12 col-md-3 col-xl-2 form-element">
      <label for="destination">{{ $t('destinations') }}</label>
      <select class="select-input" v-model="filter.destination" id="destination">
        <option value="">{{ $t('allDestinations') }}</option>
        <option v-for="destination in destinations" :value="destination.value" :text="destination.label" />
      </select>
    </div>

    <div class="col-12 col-md-3 col-xl-2 form-element">
      <label for="interest">{{ $t('interests') }}</label>
      <select class="select-input" v-model="filter.interest" id="interest">
        <option value="">{{ $t('allInterests') }}</option>
        <option v-for="interest in interests" :value="interest" :text="interestTitle(interest)" />
      </select>
    </div>

    <div class="col-12 offset-md-9 col-md-3 offset-xl-10 col-xl-2 form-element">
      <label>{{ $t('sortBy') }}</label>
      <select class="select-input" v-model="sortOrder">
        <option value="weight">{{ $t('recommendedFirst') }}</option>
        <option value="asc">{{ $t('lowPointsFirst') }}</option>
        <option value="desc">{{ $t('highPointsFirst') }}</option>
      </select>
    </div>
  </div>

  <div class="grid">
    <div v-for="award in filteredAndSortedAwards" class="col-12 col-sm-6 col-lg-4">
      <AwardCard :award="award" :key="award.beternaid"></AwardCard>
    </div>
  </div>
</div>
  `,
  props: { awards: Array, useFilters: Boolean },
  setup (props, { emit }) {
    const sortOrder = Vue.ref('weight')
    const filter = Vue.reactive({
      destination: '',
      interest: '',
    })

    const filteredAwards = Vue.computed(() => props.awards.filter(award => {
      const hasDestination = filter.destination === '' || award.destinations.includes(filter.destination)
      const hasInterest = filter.interest === '' || award.interests.includes(filter.interest)
      return hasDestination && hasInterest
    }).map((a, index) => ({ ...a, weight: a.weight ?? index + props.awards.length })))

    const filteredAndSortedAwards = Vue.computed(() => {
      return filteredAwards.value.sort((a, b) => {
        switch (sortOrder.value) {
          case 'asc':
            return a.points - b.points
          case 'desc':
            return b.points - a.points
          default:
            return a.weight - b.weight
        }
      })
    })

    const interests = Vue.computed(() => {
      return [...new Set(props.awards.flatMap(a => a.interests))]
    })

    const destinations = Vue.computed(() => {
      // eslint-disable-next-line no-useless-call
      return [...new Set(props.awards.flatMap(a => a.destinations))]
        .map(destination => ({
          label: `${destination.charAt(0).toUpperCase()}${destination.slice(1)}`,
          value: destination,
        }))
    })

    const interestTitle = (key) => {
      return (LOYALTY_INTERESTS.find(i => i.key === key))?.title
    }

    return {
      filter,
      interests,
      sortOrder,
      destinations,
      interestTitle,
      filteredAndSortedAwards,
    }
  },
}
